const AUTOPAY_PAYMENT_FAILURE_SCREEN_PREFIX = "autopay-payment-failure-screen";

export const AUTOPAY_PAYMENT_FAILURE_SCREEN_TEST_IDS = {
    ERROR_TITLE: `${AUTOPAY_PAYMENT_FAILURE_SCREEN_PREFIX}_error_title`,
    ERROR_SUB_TITLE: `${AUTOPAY_PAYMENT_FAILURE_SCREEN_PREFIX}_error_sub_title`,
    EXCLAMATION: `${AUTOPAY_PAYMENT_FAILURE_SCREEN_PREFIX}_esclamation`,
    CANCEL: `${AUTOPAY_PAYMENT_FAILURE_SCREEN_PREFIX}_cancel`,
    LOADING_INDICATOR: `${AUTOPAY_PAYMENT_FAILURE_SCREEN_PREFIX}_loading_indicator`,
    SHIMMER_CONTAINER: `${AUTOPAY_PAYMENT_FAILURE_SCREEN_PREFIX}_SHIMMER_CONTAINER`,
    LOTTIE_WRAPPER: `${AUTOPAY_PAYMENT_FAILURE_SCREEN_PREFIX}_lottie_wrapper`,
    LOTTIE_TITLE: `${AUTOPAY_PAYMENT_FAILURE_SCREEN_PREFIX}_LOTTIE_TITLE`,
    LOTTIE_SUBTITLE: `${AUTOPAY_PAYMENT_FAILURE_SCREEN_PREFIX}_LOTTIE_SUBTITLE`,
    AUTOPLACE_CTA: `${AUTOPAY_PAYMENT_FAILURE_SCREEN_PREFIX}_AUTOPLACE_CTA`,
    CONSENT_PRIMARY_CTA: `${AUTOPAY_PAYMENT_FAILURE_SCREEN_PREFIX}_CONSENT_PRIMARY_CTA`,
    CONSENT_SECONDARY_CTA: `${AUTOPAY_PAYMENT_FAILURE_SCREEN_PREFIX}_CONSENT_SECONDARY_CTA`,
    CONSENT_TIMELINE: `${AUTOPAY_PAYMENT_FAILURE_SCREEN_PREFIX}_ct`,
};
